<script setup lang="tsx">
import type { CustomFieldDefinition, User, Response } from '@/models/api-generated'
import { CF_Calendar, CF_Checkbox, CF_User, CF_URL } from '@/models/enums-generated'
import http from '@/services/http'
import { formatDate } from '@/services/utils'
import { onMounted, ref, watch } from 'vue'
import { truncate } from '@/services/utils'

const props = defineProps<{
	field: CustomFieldDefinition
	value: string
}>()

const user = ref<User | undefined>()

function fetchUser() {
	if (props.value) {
		const userId = Number.parseInt(props.value)
		http.get<Response<User>>(`api/user/${userId}`).then((a) => (user.value = a.data.data))
	}
}

function isValidUrl(value: string): boolean {
	try {
		new URL(value)
		return true
	} catch {
		return false
	}
}

onMounted(() => {
	if (props.field.type === CF_User) {
		fetchUser()
		watch(() => props.value, fetchUser)
	}
})
</script>

<template>
	<template v-if="props.field.type === CF_Checkbox">
		<i v-if="props.value" class="bi bi-circle-fill status-normal-background"></i>
		<i v-else class="bi bi-circle-fill status-verybig-background"></i>
	</template>

	<template v-else-if="props.field.type === CF_Calendar">
		{{ props.value ? formatDate(props.value) : '' }}
	</template>

	<template v-else-if="props.field.type === CF_User">
		{{ user?.label }}
	</template>
	<div v-else-if="props.field.type === CF_URL" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="props.value">
		<a v-if="isValidUrl(props.value)" :href="props.value" target="_blank" rel="noopener noreferrer">{{ truncate(props.value, 25) }}</a>
		<span v-else>{{ truncate(props.value, 25) }}</span>
	</div>

	<template v-else>{{ props.value }}</template>
</template>
